import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaIdRecorrencia = (): TabelaColuna => ({
  Chave: 'idRecorrencia',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 130 }}>Id da recorrência</div>
})
